<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <section style="margin-bottom: 1%" v-if="hasCreatePermisson">
        <a-button type="primary" @click="goToAddPurchaseOrder">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('form.AddPurchase') }}
        </a-button>
        <a-button type="primary" @click="showModal('add')">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('form.BatchAddPurchase') }}
        </a-button>
      </section>

      <a-row :gutter="16" style="display: flex; gap: 12px 0; flex-wrap: wrap">
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.purchaseOrderSn"
            :placeholder="$t(`form.PleaseEnter`) + $t(`form.purchase`) + $t(`form.OrderNumber`)"
          />
        </a-col>
        <a-col :span="6">
          <date-range-picker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseOrderStart"
            :placeholder="$t(`form.OrderTime`)"
            :start-time="formData.startTime"
            :end-time="formData.endTime"
          ></date-range-picker>
        </a-col>
        <a-col :span="6">
          <!-- 仓库名称选项 -->
          <SelectWarehouseNew
            :placeholder="$t(`form.warehouseName`) + '（' + $t(`form.SingleChoice`) + '）'"
            style="width: 100%"
            :code.sync="formData.warehouseCode"
            @change="chooseWarehouse"
          />
        </a-col>
        <a-col :span="6">
          <SearchSku style="width: 100%" @selected="handleChangeSku" />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.referenceNo"
            :placeholder="$t(`form.PleaseEnter`) + $t(`form.ReferenceNo`)"
          />
        </a-col>
        <a-col :span="6">
          <!-- 供应商 -->
          <selectSupplier
            :code="formData.supplierCode"
            @supplierIndexChange="supplierIndexChange"
          ></selectSupplier>
        </a-col>
        <a-col :span="6">
          <date-range-picker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseArrivalStart"
            :placeholder="$t(`form.WarehousingTime`)"
            :start-time="formData.arrivalTimeStart"
            :end-time="formData.arrivalTimeEnd"
          ></date-range-picker>
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.createdUser"
            @pressEnter="queryOrderList(1)"
            :placeholder="$t(`form.PleaseEnter`) + $t(`创建人`)"
          />
        </a-col>
        <a-col :span="6" v-if="isRent">
          <a-input
            allow-clear
            v-model.trim="formData.imei"
            @pressEnter="queryOrderList(1)"
            placeholder="IMEI"
          />
        </a-col>
        <a-col :span="6">
          <a-button @click="queryOrderList(1)" class="btnBgc">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`form.Search`) }}
          </a-button>
          <!-- <a csvLink [data]='dataSet4'>999</a> -->
          <a-button @click="onExport" style="margin-left: 15px">
            <i class="icon iconfont icon-upload" style="margin-right: 5px"></i>
            {{ $t(`form.Export`) }}
          </a-button>
        </a-col>
      </a-row>

      <div class="table-content">
        <div class="table-header">
          <div class="row status-list-wrap">
            <input type="hidden" v-model="formData.status" />
            <a-tabs default-active-key="" @change="setSearchStatus">
              <a-tab-pane key="">
                <template slot="tab">
                  <span>{{ $t('form.All') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane v-for="item in purchaseStatusList" :key="item">
                <template slot="tab">
                  <span>{{ $t(`form.${item}`) }}</span>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>
          <ul class="action-list" v-show="tableData.length" v-if="hasAuditPermisson">
            <li style="margin-right: 15px">
              <!-- 批量审核 -->
              <a-button class="btnBgc" @click="batchCheck">
                {{ $t(`form.Review`) }}
              </a-button>
            </li>
            <li style="margin-right: 15px">
              <!-- 批量作废 -->
              <a-button class="btnBgD" @click="batchCancel">
                {{ $t(`form.Void`) }}
              </a-button>
            </li>
            <li style="margin-right: 15px">
              <!-- 批量完结 -->
              <a-button class="btnBgc" @click="batchFinish">
                {{ $t(`form.ConfirmFinish`) }}
              </a-button>
            </li>
            <li style="margin-right: 15px">
              <a-button class="btnBgc" @click="onExportPurchaseContract">
                {{ $t(`form.ExportPurchaseContract`) }}
              </a-button>
            </li>
          </ul>
        </div>
        <div class="table-body">
          <a-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :scroll="{ x: 2000 }"
            :columns="tableColumns"
            :data-source="tableData"
            @change="headerOperation"
            rowKey="purchaseOrderId"
            :pagination="false"
            :loading="tableLoading"
            bordered
          >
            <template slot="OpeningBalanceTitle">
              <div style="display: flex; align-items: center">
                <span>{{ $t('form.openingBalance') }}</span>
                <a-tooltip placement="top">
                  <template #title>
                    <span>{{ $t(`layer.InventoryLayer14`) }}</span>
                  </template>
                  <a-icon
                    :style="{
                      fontSize: '16px',
                      color: '#1890ff',
                      marginTop: '2px',
                      marginLeft: '4px',
                    }"
                    type="exclamation-circle"
                    theme="twoTone"
                  />
                </a-tooltip>
              </div>
            </template>
            <template slot="purchaseOrderSn" slot-scope="text, record">
              <a @click="onCliCkDetail(record)" :class="{ visited: hasVisited(record) }">
                {{ record.purchaseOrderSn }}
              </a>
            </template>
            <template slot="time" slot-scope="text, record">
              <div>
                <div class="time-item">{{ $t('form.CreateAt') }}：{{ record.orderTime }}</div>
                <div class="time-item" v-if="record.estimatedArrivalTime">
                  {{ $t('form.EstimatedArrivalTime') }}：{{ record.estimatedArrivalTime }}
                </div>
                <div class="time-item" v-if="record.finishTime">
                  {{ $t('form.ReceivingCompletionTime') }}：{{ record.finishTime }}
                </div>
              </div>
            </template>
            <!-- 采购箱数 -->
            <template slot="CaseNum" slot-scope="text, record">
              {{ record.caseNum | toThousands }}
            </template>
            <!-- 采购数量 -->
            <template slot="PurchaseQuantity" slot-scope="text, record">
              {{ record.totalCount | toThousands }}
            </template>
            <!-- 当前入库 -->
            <template slot="NowCount" slot-scope="text, record">
              {{ record.nowCount | toThousands }}
            </template>
            <!-- 差异数量 -->
            <template slot="DifferentCount" slot-scope="text, record">
              {{ record.differentCount | toThousands }}
            </template>
            <!-- 已退数量 -->
            <template slot="returnedQuantity" slot-scope="text, record">
              {{ record.returnedQuantity | toThousands }}
            </template>
            <!-- opening balance -->
            <template slot="OpeningBalance" slot-scope="text, record">
              {{ record.openingBalance | toThousands }}
            </template>
            <!-- 订单金额 -->
            <template slot="TotalAmount" slot-scope="text, record">
              {{ record.totalAmount | toThousands }}
            </template>
          </a-table>
        </div>
        <div class="table-footer">
          <pagination
            :pageNo="pageNo"
            :length="pageSize"
            :total-count="total"
            @paginate="paginate"
          ></pagination>
        </div>
      </div>
    </section>
    <a-modal v-model="visible" :title="modalInfo.modalTitle" :width="500" :footer="null">
      <div class="m-content">
        <a-form-model>
          <a-form-model-item required :label="$t(`仓库列表`)">
            <SelectWarehouseNew @selected="selectedWarehouse" />
          </a-form-model-item>
          <a-form-model-item required :label="$t(`仓库货主`)">
            <SelectWarehouseShipper :wmsAppCode="wmsAppCode" :code.sync="shipperUniqueCode" />
          </a-form-model-item>
          <a-form-model-item required :label="$t(`结算组织`)" v-if="hasFMSApp">
            <SelectBU
              :code.sync="modalInfo.businessUnitCode"
              :name.sync="modalInfo.businessUnitName"
            />
          </a-form-model-item>
        </a-form-model>
        <a-upload-dragger
          v-if="warehouseUniqueCode && shipperUniqueCode"
          name="file"
          :multiple="true"
          :action="modalInfo.modalUrl"
          :data="{
            buId,
            shopCode,
            warehouseUniqueCode,
            shipperUniqueCode,
            businessUnitCode: modalInfo.businessUnitCode,
          }"
          :headers="{ Authorization: sessionId }"
          @change="handleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
        </a-upload-dragger>
        <a
          v-if="modalInfo.xlsDownloadUrl"
          target="_blank"
          class="text-info mt10"
          :href="modalInfo.xlsDownloadUrl"
        >
          {{ modalInfo.modalTitle }}{{ $t('form.Template') }}.xls
        </a>
      </div>
    </a-modal>
    <a-modal v-model="errorVisible" :title="$t('导入出错')" :width="500">
      <div class="flex mb20">
        <a-icon type="close-circle" class="text-danger" style="font-size: 30px" />
        <div class="ml10" v-html="errorMsg" />
      </div>
      <a
        v-if="modalInfo.xlsDownloadUrl"
        target="_blank"
        class="text-info"
        :href="modalInfo.xlsDownloadUrl"
      >
        {{ modalInfo.modalTitle }}{{ $t('form.Template') }}.xls
      </a>
    </a-modal>
  </div>
</template>
<script>
import { Modal } from 'ant-design-vue'
import { mapState, mapMutations, mapGetters } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import pagination from '@component/pagination'
import dateRangePicker from '@component/dateRangePicker'
import selectSupplier from '@component/selectSupplier'
import SelectWarehouseNew from '@component/selectWarehouseNew'
import SelectWarehouseShipper from '@component/selectWarehouseShipper'
import SelectBU from '@component/selectBU'
import { getCookie } from '@/common/cookie'
import fetch from '@/service/fetch'
import SearchSku from '@component/searchSku'
import { getPermission } from '@/common'
export default {
  name: 'purchaseList',
  mounted() {
    this.sessionId = getCookie('d_session_id')

    let currentShop = JSON.parse(localStorage.getItem('currentShop'))
    this.shopCode = currentShop.uniqueCode
  },
  activated() {
    this.queryOrderList()
    this.hasCreatePermisson = getPermission(['f_purchase', 'f_purchase_order_create'])
    this.hasAuditPermisson = getPermission(['f_purchase', 'f_purchase_order_audit'])
  },
  components: {
    pagination,
    dateRangePicker,
    selectSupplier,
    SearchSku,
    SelectWarehouseNew,
    SelectWarehouseShipper,
    SelectBU,
  },
  data() {
    return {
      shopCode: '',
      sessionId: '',
      status: '',
      formData: {
        purchaseOrderSn: '',
        referenceNo: '',
        imei: '',
        startTime: '',
        endTime: '',
        status: '',
        warehouseCode: '',
        tag: '',
      },
      tableLoading: false,
      pageNo: 1,
      pageSize: 10,
      orderByParam: 'created_at DESC',
      total: 0,
      selectedRowKeys: [],
      tableData: [],
      modalInfo: {
        modalTitle: '',
        modalDesc: '',
        modalUrl: '',
        xlsRequestUrl: '',
        xlsDownloadUrl: '', //模板下载链接
        businessUnitCode: '',
        businessUnitName: '',
      },
      visible: false,
      language_mapping: {
        zh: 'zh_CN',
        en: 'en_US',
        th: 'th_TH',
      },
      showText: false,
      hasCreatePermisson: false,
      hasAuditPermisson: false,
      errorVisible: false,
      errorMsg: undefined,
      wmsAppCode: undefined,
      warehouseUniqueCode: undefined,
      shipperUniqueCode: undefined,
      visitedList: [],
    }
  },
  computed: {
    ...mapState(['currentShop', 'purchaseStatusList']),
    ...mapGetters(['isRent']),
    hasFMSApp() {
      let currentIdaasApp = JSON.parse(localStorage.getItem('currentIdaasApp') || '{}')
      return !!currentIdaasApp['FMS']
    },
    tableColumns() {
      return [
        {
          dataIndex: 'purchaseOrderSn',
          title: this.$t('form.PurchaseOrderSn'),
          key: 'purchaseOrderSn',
          width: 180,
          scopedSlots: { customRender: 'purchaseOrderSn' },
        },
        {
          title: this.$t('时间'),
          dataIndex: 'time',
          width: 260,
          scopedSlots: { customRender: 'time' },
        },
        {
          title: this.$t('form.ReferenceNo'),
          dataIndex: 'referenceNo',
          width: 180,
          key: 'referenceNo',
        },
        {
          title: this.$t('form.StatusContent'),
          key: 'statusContent',
          width: 150,
          dataIndex: 'status',
          customRender: (text) => this.getStatus(text),
        },
        {
          title: this.$t('form.SupplierName'),
          key: 'supplierName',
          dataIndex: 'supplierName',
          width: 150,
        },
        {
          title: this.$t('form.ReceiverName'),
          key: 'warehouseName',
          width: 150,
          dataIndex: 'warehouseName',
        },
        // {
        //   title: this.$t('form.NumberOfBoxesPurchased'),
        //   key: 'caseNum',
        //   width: 120,
        //   dataIndex: 'caseNum',
        //   scopedSlots: { customRender: 'CaseNum' },
        // },
        {
          title: this.$t('form.TotalCount'),
          key: 'totalCount',
          width: 120,
          dataIndex: 'totalCount',
          scopedSlots: { customRender: 'PurchaseQuantity' },
        },
        {
          title: this.$t('form.NowCount'),
          key: 'nowCount',
          dataIndex: 'nowCount',
          width: 120,
          scopedSlots: { customRender: 'NowCount' },
        },
        {
          title: this.$t('form.DifferentCount'),
          key: 'differentCount',
          dataIndex: 'differentCount',
          width: 120,
          scopedSlots: { customRender: 'DifferentCount' },
        },
        {
          title: this.$t('已退数量'),
          key: 'returnedQuantity',
          dataIndex: 'returnedQuantity',
          width: 120,
          scopedSlots: { customRender: 'returnedQuantity' },
        },
        {
          slots: { title: 'OpeningBalanceTitle' },
          key: 'openingBalance',
          width: 120,
          dataIndex: 'openingBalance',
          scopedSlots: { customRender: 'OpeningBalance' },
        },
        {
          title: this.$t('form.TotalAmount'),
          key: 'totalAmount',
          width: 120,
          dataIndex: 'totalAmount',
          scopedSlots: { customRender: 'TotalAmount' },
        },
        // {
        //   title: this.$t('预计到货时间'),
        //   width: 200,
        //   dataIndex: 'estimatedArrivalTime',
        // },
        {
          title: this.$t('form.OrderType'),
          key: 'purchaseOrderType',
          width: 120,
          dataIndex: 'purchaseOrderType',
          customRender: (text) => this.getOrderType(text),
        },
        {
          title: this.$t('form.Remark'),
          key: 'note',
          width: 120,
          dataIndex: 'note',
        },
        // {
        //   title: this.$t('form.CreateAt'),
        //   key: 'OrderTime',
        //   dataIndex: 'orderTime',
        //   width: 200,
        //   sorter: true,
        // },
        // {
        //   title: this.$t('form.ReceivingCompletionTime'),
        //   key: 'finishTime',
        //   dataIndex: 'finishTime',
        //   width: 200,
        // },
        {
          title: this.$t('创建人'),
          key: 'createdUser',
          dataIndex: 'createdUser',
          width: 120,
          customRender: (text) => decodeURIComponent(text),
        },
      ]
    },
    statusListTop() {
      return [
        {
          statusName: this.$t(`form.All`), //全部
          status: '',
        },
        {
          statusName: this.$t(`form.Enabled`), //"已启用",
          status: 'open',
        },
        {
          statusName: this.$t(`form.NotActive`), //"未激活",
          status: 'close',
        },
        {
          statusName: this.$t(`form.Deleted`), //已删除,
          status: 'delete',
        },
      ]
    },
    buId() {
      return this.$store.getters.partyId
    },
    lang() {
      return this.$store.state.lang
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    supplierIndexChange(val) {
      this.formData.supplierName = val.supplierName
    },
    getStatus(text) {
      return this.$t(`form.${text}`)
    },
    getOrderType(text) {
      if (text == undefined) {
        return ''
      }
      return this.$t(`form.${text}`)
    },

    chooseWarehouse(value) {
      //选择仓库
      if (value) {
        this.formData.warehouseCode = value
      } else {
        this.formData.warehouseCode = ''
      }
    },
    hasVisited(record) {
      return this.visitedList.includes(record.purchaseOrderSn)
    },
    onCliCkDetail(record) {
      this.visitedList.push(record.purchaseOrderSn)
      this.$addPane({
        view: 'purchaseDetail/' + record.purchaseOrderId,
        name: '订单详情',
        params: {
          orderId: record.purchaseOrderId,
          orderSn: record.purchaseOrderSn,
        },
        route: '/purchase/purchaseDetail?id=' + record.purchaseOrderId,
      })
    },
    chooseOrderStart(date) {
      this.formData.startTime = date.start_time
      this.formData.endTime = date.end_time
    },
    chooseArrivalStart(date) {
      this.formData.arrivalTimeStart = date.start_time
      this.formData.arrivalTimeEnd = date.end_time
    },
    showModal(type) {
      if (!this.currentShop) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.NoOwnerInformation`),
        })
        return
      }
      let mapping = {
        add: {
          modalTitle: this.$t('form.BatchRecordOrders'),
          modalDesc: this.$t('form.AddProductNote'),
          modalUrl: api.batchSavePurchaseOrder + `?language=${this.language_mapping[this.lang]}`,
          businessUnitCode: undefined,
          businessUnitName: undefined,
          xlsDownloadUrl:
            this.$i18n.locale == 'zh'
              ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/%E9%87%87%E8%B4%AD%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF20240523.xlsx'
              : 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/PurchaseOrderBatchImportTemplate20240523.xlsx',
        },
      }
      this.modalInfo = mapping[type]
      this.$nextTick(() => {
        this.visible = true
      })
    },
    onExport() {
      // 传空导出全部
      let data = {}
      if (!this.selectedRowKeys.length) {
        data = {
          purchaseOrderSn: this.formData.purchaseOrderSn,
          orderTimeStart: this.formData.startTime,
          orderTimeEnd: this.formData.endTime,
          warehouseCode: this.formData.warehouseCode,
          referenceNo: this.formData.referenceNo,
          barcode: this.formData.barcode,
          imei: this.formData.imei,
          createdUser: this.formData.createdUser,
          supplierName: this.formData.supplierName,
          arrivalTimeStart: this.formData.arrivalTimeStart,
          arrivalTimeEnd: this.formData.arrivalTimeEnd,
          orderByParam: this.orderByParam,
          shopCode: this.shopCode,
        }
      } else {
        data = {
          purchaseOrderIds: this.selectedRowKeys,
          shopCode: this.shopCode,
        }
      }
      fetch(
        api.purchaseOrderExport + `?language=${this.language_mapping[this.lang]}&cpid=${this.buId}`,
        {
          method: 'POST',
          body: data,
        }
      ).then((res) => {
        if (res?.result?.taskId) {
          this.$message.success(this.$t('创建导出任务成功,请前往【数据中心/下载中心】下载'))
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 导出采购合同
    onExportPurchaseContract() {
      if (!this.selectedRowKeys.length) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`form.ChooseGoodsExport`),
        })
        return
      }
      fetch(api.purchaseOrderExportPurchaseContract, {
        method: 'POST',
        body: {
          purchaseOrderId: this.selectedRowKeys[0],
          shopCode: this.shopCode,
        },
      }).then((res) => {
        if (res?.result?.taskId) {
          this.$message.success(this.$t('创建导出任务成功,请前往【数据中心/下载中心】下载'))
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    goToAddPurchaseOrder() {
      this.$router.push('addPurchase')
    },
    queryOrderList(first_page = false) {
      first_page && (this.pageNo = 1)
      this.$nextTick(async () => {
        let data = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          purchaseOrderSn: this.formData.purchaseOrderSn,
          orderTimeStart: this.formData.startTime,
          orderTimeEnd: this.formData.endTime,
          warehouseCode: this.formData.warehouseCode,
          referenceNo: this.formData.referenceNo,
          barcode: this.formData.barcode,
          imei: this.formData.imei,
          createdUser: this.formData.createdUser,
          supplierName: this.formData.supplierName,
          arrivalTimeStart: this.formData.arrivalTimeStart,
          arrivalTimeEnd: this.formData.arrivalTimeEnd,
          orderByParam: this.orderByParam,
        }
        if (this.formData.status !== -1) {
          data.status = this.formData.status
        }
        this.tableLoading = true
        let res = await http({
          instance: this,
          type: 'post',
          url: api.purchaseOrderList,
          data,
        })
        let purchaseOrderList = [...(res.result.purchaseOrderList || '')]
        this.tableData = purchaseOrderList
        this.total = res.result.total
        this.tableLoading = false
      })
    },
    setSearchStatus(status) {
      this.$set(this.formData, 'tag', '')
      this.$set(this.formData, 'status', status)
      this.queryOrderList(1)
      this.selectedRowKeys = []
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    // 排序
    headerOperation(pagination, filters, sorter = {}) {
      const { columnKey, order } = sorter
      if (columnKey === 'OrderTime') {
        this.orderByParam = order === 'ascend' ? 'created_at ASC' : 'created_at DESC'
        this.queryOrderList()
      }
    },
    batchCheck() {
      this.batchHandle({
        modalAction: this.$t('form.Review'),
        url: api.batchCheckPurchaseOrder,
      })
    },
    batchCancel() {
      this.batchHandle({
        modalAction: this.$t('form.Void'),
        url: api.batchCancelPurchaseOrder,
      })
    },
    batchFinish() {
      this.batchHandle({
        modalAction: this.$t('form.ConfirmFinish'),
        url: api.batchFinishPurchaseOrder,
      })
    },
    confirmSelect() {
      let is_empty = false
      if (this.selectedRowKeys.length === 0) {
        is_empty = true
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.SelectAtLeastOneItem`),
        })
      }
      return is_empty
    },
    batchHandle({ modalAction, url }) {
      if (this.confirmSelect()) return
      Modal.confirm({
        title: this.$t('form.Tips'),
        content: `${this.$t('form.Whether')} ${modalAction} ${this.$t('form.SelectOrder')}`,
        okText: this.$t('form.Confirm'),
        cancelText: this.$t('form.Cancel'),
        onOk: () => {
          let purchaseOrderIds = [...this.selectedRowKeys]
          this.commonHttp({
            url,
            modalAction,
            data: { purchaseOrderIds },
          }).then(() => {
            this.queryOrderList()
          })
        },
      })
    },
    commonHttp({ url, modalAction, data }) {
      return new Promise((resolve) => {
        http({
          instance: this,
          type: 'post',
          hasLoading: true,
          url,
          data,
          success: (res) => {
            this.$success({
              title: this.$t(`layer.Success`),
              content: `${modalAction}${this.$t('form.FINISH')}`,
            })
            resolve(res)
          },
        })
      })
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryOrderList()
    },
    handleChange(info) {
      this.shopCode = JSON.parse(localStorage.getItem('currentShop'))?.uniqueCode
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          this.queryOrderList()
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
        } else {
          this.errorMsg = `${info.file.response.msg} <br /> ${this.$t(
            '请重新下载导入模板,检查后重新上传'
          )}`
          this.errorVisible = true
        }
        this.visible = false
      } else if (status === 'error') {
        this.errorMsg = `${info.file.name} <br /> ${this.$t('请重新下载导入模板,检查后重新上传')}`
        this.errorVisible = true
        this.visible = false
      }
    },
    handleChangeSku(data) {
      this.formData.barcode = data.barcode
    },
    selectedWarehouse(data) {
      this.wmsAppCode = data.wmsAppCode
      this.warehouseUniqueCode = data.uniqueCode
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
.btnBgc {
  background-color: #0088ff;
  color: #ffffff;
}
.btnBgD {
  background-color: #ff4d4f;
  color: #ffffff;
}
.batchBgc {
  color: #0088ff;
  border-color: #0088ff;
}
.action-list {
  display: flex;
}
.flex-btns {
  max-width: 120px;
  &.flex {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .t-btn {
    cursor: pointer;
    margin-right: 10px;
    color: $primary-color;
    white-space: nowrap;
  }
}
.upload-content {
  padding: 20px;
}
.mt10 {
  margin-top: 10px;
  display: block;
}
.visited {
  color: red; /*已访问的链接颜色*/
}

.time-item {
  font-size: 13px;
}
</style>
